import React from "react";
import styles from "./MiniCardWrapper.module.scss";
import Image from "next/image";
import { Images } from "@/utils/constants/imageRelativePaths";
import { AstroSunDetails, MiniCardDetailsType } from "../../Enum";

interface MiniCardProps {
  data: MiniCardDetailsType[];
  sunDetails?: AstroSunDetails;
}

const MiniCard = ({ data, sunDetails }: MiniCardProps) => {
  return (
    <div className={styles.miniCardWrapper}>
      {data.map(({ image, names }, index) => {
        return (
          <div className={styles.miniCard} key={index}>
            <div
              className={`${styles.imageWrapper} ${
                image === Images.sun ? `${styles.orange}` : `${styles.purple}`
              }`}
            >
              <Image src={image} alt="day" height={20} width={20} />
            </div>
            <ul className={styles.textWrapper}>
              {names.map((name, index) => (
                <li key={index}>
                  {name} -{" "}
                  <span>
                    {sunDetails?.[name.toLowerCase() as keyof AstroSunDetails]}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
};

export default MiniCard;
